const SparkleIcon = ({ width = 22, height = 22, fill = "#C4C2F4", className = "", ...props }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 22 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            {...props}
        >
            <path
                d="M9.53038 3.19018C9.85731 1.59068 12.1427 1.59069 12.4696 3.19018L13.1775 6.65331C13.2978 7.24208 13.7579 7.70221 14.3467 7.82255L17.8098 8.53038C19.4093 8.85731 19.4093 11.1427 17.8098 11.4696L14.3467 12.1775C13.7579 12.2978 13.2978 12.7579 13.1775 13.3467L12.4696 16.8098C12.1427 18.4093 9.85731 18.4093 9.53038 16.8098L8.82255 13.3467C8.70221 12.7579 8.24208 12.2978 7.65331 12.1775L4.19018 11.4696C2.59068 11.1427 2.59069 8.85731 4.19018 8.53038L7.65331 7.82255C8.24208 7.70221 8.70221 7.24208 8.82255 6.65331L9.53038 3.19018Z"
                fill={fill}
            />
            <path
                d="M5 22C4.44771 22 4 21.5523 4 21C4 20.4477 4.44771 20 5 20C5.55228 20 6 20.4477 6 21C6 21.5523 5.55228 22 5 22Z"
                fill={fill}
            />
            <path
                d="M17 2C16.4477 2 16 1.55228 16 1C16 0.447715 16.4477 -2.41411e-08 17 0C17.5523 2.41411e-08 18 0.447715 18 1C18 1.55228 17.5523 2 17 2Z"
                fill={fill}
            />
            <path
                d="M21 6C20.4477 6 20 5.55228 20 5C20 4.44771 20.4477 4 21 4C21.5523 4 22 4.44771 22 5C22 5.55228 21.5523 6 21 6Z"
                fill={fill}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M21.3147 13.9953C21.7804 14.1692 22.017 14.6876 21.8432 15.1532C20.7173 18.1697 18.3801 20.5926 15.4228 21.8302C14.9643 22.0221 14.4371 21.806 14.2452 21.3474C14.0533 20.8889 14.2694 20.3617 14.728 20.1698C17.2274 19.1238 19.2052 17.0734 20.1568 14.5238C20.3306 14.0581 20.849 13.8215 21.3147 13.9953Z"
                fill={fill}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.02077 0.684638C8.19494 1.15018 7.95874 1.66877 7.4932 1.84294C4.92955 2.80206 2.87073 4.8029 1.83251 7.33064C1.64367 7.79043 1.11785 8.01007 0.658064 7.82122C0.198279 7.63237 -0.0213602 7.10655 0.167486 6.64677C1.39534 3.6573 3.82798 1.29233 6.86247 0.15706C7.32801 -0.0171093 7.8466 0.219095 8.02077 0.684638Z"
                fill={fill}
            />
            <path
                d="M1 18C0.447715 18 -2.41411e-08 17.5523 0 17C2.41411e-08 16.4477 0.447715 16 1 16C1.55228 16 2 16.4477 2 17C2 17.5523 1.55228 18 1 18Z"
                fill={fill}
            />
        </svg>
    );
};

export default SparkleIcon;